/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { ErrorMessage, HelperMessage } from '@atlaskit/form';
import EditorInfoIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { messages } from '../i18n';

const compiledStyles = cssMapCompiled({
	infoPopupLearnMoreWrapper: {
		display: 'block',
		marginTop: token('space.100'),
	},
	divWrapper: {
		display: 'flex',
		alignItems: 'center',
	},
	infoIconWrapper: {
		margin: 0,
		marginLeft: token('space.050'),
		maxHeight: token('space.200'),
	},
});
export function InfoDetailLearnMoreLink(): React.JSX.Element {
	return (
		<div css={compiledStyles.infoPopupLearnMoreWrapper}>
			{/* eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlaskit/design-system/no-html-anchor */}
			<a target="_blank" rel="noreferrer" href="#">
				<FormattedMessage {...messages.learnMore} />
			</a>
		</div>
	);
}
export function TeamNameErrorMsg({ errorMsg }: { errorMsg: string }): React.JSX.Element {
	return <ErrorMessage testId="team-name-empty-error">{errorMsg}</ErrorMessage>;
}
export function TeamNameInfoMsg(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<HelperMessage testId="team-name-info-msg" aria-hidden="true">
			<div css={compiledStyles.divWrapper}>
				<FormattedMessage {...messages.teamNameFieldInfoMessage} />
				<Tooltip content={formatMessage(messages.teamNameFieldInfoDetail)}>
					<span css={compiledStyles.infoIconWrapper} tabIndex={0} role="button">
						<EditorInfoIcon
							label={formatMessage(messages.teamNameFieldInfoDetail)}
							color="currentColor"
							size="small"
						/>
					</span>
				</Tooltip>
			</div>
		</HelperMessage>
	);
}
